<div class="section" id="about">
    <div class="container">
        <div class="card" data-aos="fade-up" data-aos-offset="10">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="card-body">
                        <div class="h4 mt-0 title">About Me</div>

<!--                         <p align="justify">I am a passionate software developer with a strong background in web
                            application development.
                            My journey in tech began back home in India, where my interest in building digital solutions
                            led me to pursue a bachelor’s degree in computer science.
                            After completing my master’s in the U.S., I started working as a Software Developer,
                            building and delivering web applications that solve real-world problems.
                            Along the way, I’ve always believed that learning is a never-ending process, and I embrace
                            the value of mistakes as stepping stones to success.</p>

                        <p align="justify">While I enjoy the challenges and growth opportunities in my full-time role, 
                            I’ve always harbored a dream to create something of my own. From a young age, 
                            I envisioned starting my own company, not confined to any particular industry. Recently, 
                            I took a step towards realizing that dream by founding <b>VK Global</b>. 
                        </p> -->
                        <p>
                            I’m a <b>Full-Stack Engineer</b> with <b>{{ yearsOfExperience }}+ years</b> of experience designing scalable systems, 
                            leading end-to-end development, and delivering high-impact features across enterprise and consumer applications. 
                            I specialize in <b>React</b>, <b>Node.js</b>, <b>PostgreSQL</b>, <b>distributed microservices</b>, <b>secure ETL pipelines</b>, <b>cloud-native engineering</b>, and integrating <b>Generative AI agents</b> into production workflows.
                        </p>

                        <p>
                            I’ve built <b>enterprise-grade software</b> at <b>Paycom</b> and <b>Cognizant</b>, owning services from architecture through deployment. 
                            Beyond work, I’ve independently built systems like <b>Cricket Fever</b> (live streaming platform), <b>QuickTrailer</b> (multilingual media discovery app), and multiple <b>AI-driven automation tools</b>—strengthening my ability to design resilient backends, optimize performance, and build seamless user experiences.
                        </p>

                        <p>
                            I bring strong <b>system design thinking</b>, a <b>bias for action</b>, and a <b>product-focused mindset</b>. I thrive in environments where I can <b>own problems end-to-end</b>, improve reliability and performance, simplify complex architectures, and collaborate closely with cross-functional teams to ship real customer value.
                        </p>
                        
                        <p>
                            I’m passionate about building <b>scalable platforms</b>, driving <b>engineering excellence</b>, and leveraging <b>AI</b> to push the next generation of intelligent, user-centric software.
                        </p>
                        <p align="justify"> 
                            To learn more about my background and work, 
                            feel free to explore my portfolio or get in touch by filling out the contact form below.
                        </p> 
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="card-body">
                        <div class="h4 mt-0 title">Basic Information</div>
                        <div class="row">
                            <div class="col-sm-4">
                                <strong class="text-uppercase">Date of Birth:</strong>
                            </div>
                            <div class="col-sm-8">May 10, 1998</div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-4">
                                <strong class="text-uppercase">Email:</strong>
                            </div>
                            <div class="col-sm-8">vamshitanz@gmail.com</div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-4">
                                <strong class="text-uppercase">Mobile No:</strong>
                            </div>
                            <div class="col-sm-8">+1 9407582686</div>
                        
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-4">
                                <strong class="text-uppercase">Address:</strong>
                            </div>
                            <div class="col-sm-8">Lewisville, Texas, US - 75067</div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-4">
                                <strong class="text-uppercase">Language:</strong>
                            </div>
                            <div class="col-sm-8">English, Telugu, Hindi </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
